module.exports = __webpack_public_path__ + "img/mining.885260ce.png";